/**
 * PilotHintContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled pilot hint container.
 */
const PilotHintContainer = styled.div`
  align-items: center;
  bottom: ${Screen.widthRatio * 117}px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
`;

export default withOpacity(PilotHintContainer);
